export default {
  productNotFound: {
    id: 'buyback_product_page_not_found',
    defaultMessage: 'Product not found',
  },
}
